import clsx from 'clsx';

interface ExecutionTimeProps {
    className?: string;
    label?: string;
    time: number;
}

const MILLISECONDS_MULTIPLIER = 1000;
const WARNING_THRESHOLD = 50;
const DANGER_THRESHOLD = 200;

const ExecutionTime = ({
    className,
    time,
    label = 'Execution time'
}: ExecutionTimeProps) => {
    const ms = time * MILLISECONDS_MULTIPLIER;
    let cls = 'text-green-8';
    if (ms > WARNING_THRESHOLD) {
        cls = 'text-orange-4';
    }
    if (ms > DANGER_THRESHOLD) {
        cls = 'text-red-8';
    }
    return (
        <div className={clsx(cls, className)}>
            {label}: {time} ms
        </div>
    );
};

export default ExecutionTime;
